import { PharmaStpFileApiResponse } from "../../../api/bigQuery/pharmaStpFileOrders";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { logError } from "../../../utils/customLogger";
import { NycbsExternalFilterPayload } from "../utils/nycbsExternalFilterPayload";
import { NycbsExternalTableState } from "../types/nycbsExternalTableState";
import { fetchNycbsExternalData } from "./fetchNycbsExternalData";

/**
 * makePostCallForInitialDataFetch - API Call for Initial Load
 *
 * Purpose: Fetches initial data when component mounts.
 * This is called once on component mount to load the first page of data.
 *
 * @param payload - Filter payload containing search params
 * @param setNycbsExternalState - State setter for API response
 * @param setTableData - State setter for table data
 */
export const makePostCallForInitialDataFetch = async (
  payload: NycbsExternalFilterPayload,
  setNycbsExternalState: React.Dispatch<
    React.SetStateAction<NycbsExternalTableState>
  >,
  setTableData: React.Dispatch<React.SetStateAction<PharmaStpFileModel[]>>,
): Promise<void> => {
  try {
    setNycbsExternalState((prev) => ({
      ...prev,
      loading: true,
      error: null,
    }));

    const response: PharmaStpFileApiResponse =
      await fetchNycbsExternalData(payload);

    if (response.success) {
      setNycbsExternalState({
        data: response,
        loading: false,
        error: null,
        showInlineLoader: false,
      });
      setTableData(response.rows);
    } else {
      setNycbsExternalState((prev) => ({
        ...prev,
        loading: false,
        error: response.message || "Failed to fetch data",
      }));
    }
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "An unknown error occurred";
    setNycbsExternalState((prev) => ({
      ...prev,
      loading: false,
      error: errorMessage,
    }));
    logError(error as Error, "Error in makePostCallForInitialDataFetch");
  }
};
